/**
 * GS8 — how far the pinned grid header already occupies at the top of the viewport, published to
 * a section's subtree so the stylesheet keeps the sticky offset and the scroll correction in step
 * from the one value.
 */
export const GRID_SECTION_OFFSET_PROPERTY = "--cl-section-offset";
